const state = {
  currentTime: new Date(),
  hasLoadedOnce: false,
  search: '',
  filters: {
    accounts: [],
    excludedCategories: ['system'],
    excludedAccounts: [],
    direction: 'both',
    accumulated: true,
    quantity_min: '0.1',
    quantity_max: '0',
    accumulated_min: '0',
    accumulated_max: '0',
    time_min_pre: '2160',
    time_min: '',
    time_min_time: '',
    time_max: '',
    time_max_time: ''
  }
}
const getters = {
  getExcludedAccounts: (state, getters, rootState, rootGetters) => {
    let excludedAccounts = []
    state.filters.excludedAccounts.forEach(function (account) {
      excludedAccounts = excludedAccounts.concat([account.text])
    })
    state.filters.excludedCategories.forEach(function (category) {
      excludedAccounts = excludedAccounts.concat(rootGetters.getCategories[category])
    })
    return excludedAccounts
  },
  getFilterParams: (state, getters, rootState, rootGetters) => {
    let params = {}
    if (state.filters.accumulated) {
      params = {
        chain: rootState.options.selectedChain,
        symbol: rootState.options.selectedChain.toUpperCase(),
        direction: state.filters.direction,
        accumulated: state.filters.accumulated,
        accumulated_min:
          parseFloat(state.filters.accumulated_min) || null,
        accumulated_max:
          parseFloat(state.filters.accumulated_max) || null,
        quantity_min: parseFloat(state.filters.quantity_min) || null,
        quantity_max: parseFloat(state.filters.quantity_max) || null,
        time_min: new Date(getters.getTimeMin),
        time_max: new Date(getters.getTimeMax),
        excludes:
          rootState.options.selectedChain === 'eos'
            ? [] // getters.getExcludedAccounts    // filtering to be done on frontend
            : []
      }
    } else {
      params = {
        chain: rootState.options.selectedChain,
        symbol: rootState.options.selectedChain.toUpperCase(),
        direction: state.filters.direction,
        accumulated: state.filters.accumulated,
        quantity_min: parseFloat(state.filters.quantity_min) || null,
        quantity_max: parseFloat(state.filters.quantity_max) || null,
        time_min: new Date(getters.getTimeMin),
        time_max: new Date(getters.getTimeMax),
        excludes:
          rootState.options.selectedChain === 'eos'
            ? [] // getters.getExcludedAccounts   // filtering to be done on frontend
            : []
      }
    }
    return { accounts: state.filters.accounts, params: params }
  },
  getRouteParams: (state, getters, rootState, rootGetters) => {
    const requiredParams = {
      accounts: state.filters.accounts.join('-'),
      time_min: getters.getTimeMin,
      time_max: getters.getTimeMax,
      excludedAccounts: state.filters.excludedAccounts.map(acc => acc.text).join('-'),
      excludedCategories: state.filters.excludedCategories.join('-')
    }
    const defaultParams = {
      direction: 'both',
      accumulated: true,
      quantity_min: '0.1',
      quantity_max: '0',
      accumulated_min: '0',
      accumulated_max: '0'
    }
    let changedParams = requiredParams
    Object.entries(defaultParams).forEach(([key, val]) => {
      if (state.filters[key] !== val) {
        changedParams[key] = state.filters[key]
      }
    })
    return changedParams
  },
  getTimeMin: state => {
    let currentTime = new Date(state.currentTime)
    if (state.filters.time_min_pre !== 'custom') {
      return new Date(currentTime.setHours(currentTime.getHours() - parseInt(state.filters.time_min_pre))).getTime()
    } else {
      return new Date(state.filters.time_min + 'T' + state.filters.time_min_time).getTime()
    }
  },
  getTimeMax: state => {
    if (state.filters.time_min_pre !== 'custom') {
      return state.currentTime.getTime()
    } else {
      return new Date(state.filters.time_max + 'T' + state.filters.time_max_time).getTime()
    }
  }
}
const actions = {
  addAccounts ({ commit, state }, account) {
    commit('addAccounts', account)
  }
}
const mutations = {
  setTime (state) {
    state.currentTime = new Date()
  },
  updateFilter (state, data) {
    Reflect.set(state.filters, data.key, data.value)
  },
  setSearch (state, payload) {
    state.search = payload.toLowerCase().trim()
  },
  addAccounts (state, account) {
    state.hasLoadedOnce = true
    if (account.reset) {
      state.filters.accounts = account.accounts
    } else {
      if (account.accounts.length === 1 && state.filters.accounts.includes(account.accounts[0])) {
        let index = state.filters.accounts.indexOf(account.accounts[0])
        if (index > -1) {
          state.filters.accounts.splice(index, 1)
        }
      } else {
        state.filters.accounts = state.filters.accounts.concat(account.accounts)
      }
    }
    state.search = state.filters.accounts.join('-')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
